/**
 * Extract image files from a paste event's clipboard, for "paste a screenshot
 * into a composer" support. Shared so any composer can wire it to its own file
 * handler (FRONT-245).
 *
 * Returns the image `File[]` only when the clipboard carries image file(s) AND
 * no real text. If the clipboard also has plain text (e.g. an Excel/Outlook
 * cell copy, which puts a bitmap on the clipboard alongside the text), it
 * returns an empty array so the normal text paste wins and the user's text is
 * never silently dropped. An empty result means "let the default paste happen."
 *
 * Typed against the minimal `clipboardData` shape so it accepts both React
 * synthetic clipboard events and native ones without a framework dependency.
 */
export function clipboardImageFiles(e: { clipboardData?: DataTransfer | null }): File[] {
  const items = e.clipboardData?.items;
  if (!items) return [];
  const list = Array.from(items);
  if (list.some((item) => item.kind === 'string' && item.type === 'text/plain')) return [];
  const images: File[] = [];
  for (const item of list) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile();
      if (file) images.push(file);
    }
  }
  return images;
}
